
import React, { useState, useEffect } from 'react';
import { fetchCartProducts, getProducts, showWishList } from './utils/functions';
import { preloader } from './utils/icons';
import Swipe from './Components/Layout/Swipe';
import Grid from './Components/Layout/Grid';

const Products = ({ attributes }) => {
    const [currentIndex, setCurrentIndex] = useState(products?.length - 1);
    const [productId, setProductId] = useState();
    const [cartProductsList, setCartProductsList] = useState();
    const [wishList, setWishList] = useState();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [caption, setCaption] = useState('');

    const [productInfo, setProductInfo] = useState();
    const [cartProductAddLoading, setCartProductAddLoading] = useState(false);
    const { categories, limit, order_by, order } = attributes;

    // Get woocommerce products 
    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            const products = await getProducts(categories[0] ? categories[0] : '', limit, order_by, order);
            if (products?.data !== "Product Not Found") {
                setProducts(products?.data);
                setCurrentIndex(products?.data?.length - 1);
            }
            setLoading(false);
        }
        fetchProducts();
    }, [categories, limit, order_by, order]);

    // First item select cart button 
    useEffect(() => {
        if (products) {
            setProductId(products[products?.length - 1]?.id);
        }
    }, [products?.length]);

    useEffect(() => {
        // Fetch Cart Products 
        const getCartProducts = async () => {
            const products = await fetchCartProducts();
            setCartProductsList(products?.data);
        }
        getCartProducts();

        // Fetch Wishlist products 
        const fetchWishList = async () => {
            const products = await showWishList();
            setWishList(products?.data);
        }
        fetchWishList();
    }, []);

    useEffect(() => {
        const product = products?.find(product => product.id === productId);
        setProductInfo(product);
    }, [productId]);

    if (loading) {
        return <div className='preloaderIcon'>{preloader}</div>;
    }

    const swipeProps = {
        products, currentIndex, setCurrentIndex, setCartProductsList, cartProductsList, productId, setProductId, setCaption, caption, productInfo, wishList, setWishList, cartProductAddLoading, setCartProductAddLoading
    }

    const gridProps = {
        products, attributes, cartProductAddLoading, setCartProductAddLoading
    }

    return products?.length ? <div className='MainContainer'>
        <Grid {...gridProps} />

        <div className='cardContainer bpswnSwipeLayout'> <Swipe {...swipeProps} /></div>
    </div> : <div className='msg'><h3>Product Not Found</h3></div>
}
export default Products;